<template>
    <div class="chartBox">
        <div class="bg-color-black">
            <div class="d-flex pt-2 pl-2 flexStart">
                <div style="color:#5cd9e8;margin-right: 10px;">
                    <i class="el-icon-s-data"></i>
                </div>
                <div class="flexStart">
                    <span class="fs-xl text mx-2" style="margin-right: 10px;">各系/各专业{{$store.state.pmid==12?'投档':'招生'}}数据</span>
                    <dv-decoration-1 style="width:30%;height:1rem;" />
                </div>
            </div>
            <div v-if="!showFull" id="animBox" ref="#animBox" class="d-flex jc-center body-box" @mouseenter="enterbox"
                @mouseleave="leavebox" style="height:calc(100% - 30px);margin-top: 10px;overflow-y: scroll">
                <div class="prograssBarBox">
                    <div class="boxItem flexCenter" v-for="(a, ia) in config.data" :key="ia" @click="showData(a)">
                        <div class="itemContainer">
                            <div class="flexBetween">

                                <div v-if="pmid == 1" class="flexStart">
                                    <div v-if="ia < 5" class="rank">No.{{ ia + 1 }}</div>
                                    <div v-if="ia > 4" class="rank">No.{{ ia - 4 }}</div>
                                    <div class="name">{{ a.title }}</div>
                                </div>

                                <div v-if="pmid != 1" class="flexStart">
                                    <div class="rank">No.{{ ia + 1 }}</div>
                                    <div class="name">{{ a.title }}</div>
                                </div>


                                <div class="value flexStart">
                                    <span v-if="(a.zs_count > a.item_plan) || (a.zs_count == a.item_plan)"
                                        style="color: #ff0">{{ a.zs_count }}</span>
                                    <span v-if="a.zs_count < a.item_plan">{{ a.zs_count }}</span>
                                    <span style="margin-left: 5px;">/{{ a.item_plan }}<span
                                            style="margin-left: 2px;">人</span></span>
                                </div>
                            </div>
                            <div
                                style="margin-top: 5px;border-bottom: 2px solid rgba(19, 112, 251, 0.5);padding-bottom: 2px;">
                                <el-progress :percentage="a.percent" :show-text="false"></el-progress>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="showFull" class="d-flex jc-center body-box"
                style="height:calc(100% - 30px);margin-top: 10px;overflow-y: scroll">
                <dv-scroll-ranking-board :config="config" style="width: 100%; height: 100%;" />
            </div>
        </div>

        <xibuData :zsdata="config" v-if="datashow" :xibu_id="xibuId"></xibuData>
    </div>
</template>

<script>
import echartMixins from "../../js/resizeMixins";
import xibuData from "../../../manage/student/components/xibu_zsnum.vue"
export default {
    components: {
        xibuData
    },
    data() {
        return {
            xibuId: 0,
            showFull: false,
            step: 65.5,
            timer: null,
            stepTime: 50,
            set1: null,
            set2: null,
            set3: null,
            datashow: false
        };
    },
    props: {
        config: {
            type: Object,
            default: {
                data: [],
                waitTime: 4000,
                unit: "人"
            }
        },
        pmid: {
            type: Number,
            default: 1
        },
    },
    mixins: [echartMixins],
    mounted() {
        let _this = this
        clearInterval(this.timer)
        this.set1 = setTimeout(() => {
            _this.autoScroll('#animBox')

        }, 5000)

    },
    methods: {
        showData(a) {
            // console.log(a)
            if (a.pid == 0) {
                this.xibuId = a.id;
                this.datashow = true
            }
        },
        leavebox() {
            clearTimeout(this.set1)
            clearTimeout(this.set2)
            clearTimeout(this.set3)
            clearInterval(this.timer)
            this.autoScroll('#animBox', 10)
        },
        enterbox() {
            clearTimeout(this.set1)
            clearTimeout(this.set2)
            clearTimeout(this.set3)
            clearInterval(this.timer)
        },
        autoScroll(dom) {
            let _this = this
            let parentDom = this.$refs[dom]
            // let parentDom = document.querySelector(dom) //获取滚动元素

            this.timer = setInterval(() => {
                //判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
                // console.log(92,dom,parentDom)
                if ((parentDom.scrollTop + parentDom.clientHeight) < parentDom.scrollHeight) {
                    parentDom.scrollTop++ // 元素自增距离顶部
                } else {
                    clearTimeout(this.set1)
                    clearTimeout(this.set2)
                    clearTimeout(this.set3)
                    clearInterval(_this.timer)
                    this.set2 = setTimeout(function () {
                        parentDom.scrollTop = 0
                    }, 5000)
                    this.set3 = setTimeout(function () {
                        _this.autoScroll('#animBox')
                    }, 10000)
                }
            }, _this.stepTime)
        },
    },
    beforeRouteLeave(to, from, next) {
        next(vm => {
        })
        clearTimeout(this.set1)
        clearTimeout(this.set2)
        clearTimeout(this.set3)
        clearInterval(this.itimertl)
    },
    beforeDestroy() {
        clearTimeout(this.set1)
        clearTimeout(this.set2)
        clearTimeout(this.set3)
        clearInterval(this.timer)
    },
    destroyed() {
        clearTimeout(this.set1)
        clearTimeout(this.set2)
        clearTimeout(this.set3)
        clearInterval(this.timer)
        window.onresize = null;
    },
};
</script>

<style scope lang="less" type="text/less">
.chartBox {
    width: 100%;
    height: 100%;

    //隐藏滚动条
    ::-webkit-scrollbar {
        width: 0px;
        height: 0px;
    }

    .anim {
        transition: all 5s;
        margin-top: -65.5px;
    }
}

.prograssBarBox {
    .boxItem {
        height: 65.5px;

        //padding: 15px 10px;
        .itemContainer {
            width: 100%;
        }

        .rank {
            width: 40px;
            color: #1370fb;
        }
    }
}
</style>
